/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import {
    string, shape, bool, arrayOf, array, object,
} from 'prop-types';
import { selectedSkuType } from '../common/types';

import GraphqlFoodProductDetailsTab from '../GraphqlFoodDetailsUI/GraphqlFoodDetailsUI';
import GraphqlProductDetailsTab from '../GraphqlProductDetailsUI';
import GraphqlProductDetailsUIAlt from '../GraphqlProductDetailsUIAlt';
import GraphqlContentPage from '../../../GraphqlContentPage/GraphqlContentPage';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import ProductDetailsTab from '../ProductDetailsTab';

const ProductDetails = (props) => {
    const {
        pdpVariantName,
        product,
        selectedSku,
        content,
        isPassportBundleProduct,
        clubDescription,
        showProductDetailsHere,
        productBaseContent,
        isPmallAltDescriptionLocation,
        isDescriptionTabEnabled,
        isSinglePlaThree,
        renderDescriptionOnly,
        renderContentOnly,
        isPDPVariationDesign,
        isPdpRedesignEnabled,
        isPdpRedesignShortEnabled,
        isPlaRedesignEnabled,
        isPdpRedesignFood,
    } = props;

    if (isDescriptionTabEnabled && (product.brandId === '1026' || product.brandId === '1027')) {
        return (
            <GraphqlContentPage isDescriptionTabEnabled product={product} productBaseContent={productBaseContent} restrictGraphqlCPClickstreamEvent />
        );
    }

    const { presentation_family: presentationFamily = '' } = useContext(CrossMerch);
    let response = null;

    if ((showProductDetailsHere && !isPDPVariationDesign) || isPdpRedesignEnabled || isPlaRedesignEnabled) {
        response = (
            <GraphqlProductDetailsTab
                shortDescription={product.shortDescription}
                productContents={product.productContents}
                longDescription={product.longDescription}
                partNumber={product.partNumber}
                productBrand={product?.brand}
                presentationFamily={presentationFamily}
                selectedSku={selectedSku}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                isPromoRestricted={product?.isPromoRestricted}
                productBaseContent={productBaseContent}
                content={content}
                productName={product.name}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
            />
        );
    }
    if (showProductDetailsHere && isPDPVariationDesign) {
        response = (
            <ProductDetailsTab
                productShortDescription={product.shortDescription}
                selectedSku={selectedSku}
                productLongDescription={product.longDescription}
                partNumber={product?.partNumber}
            />
        );
    }
    if (presentationFamily === 'food' && !isPlaRedesignEnabled) {
        response = (showProductDetailsHere && (
            <GraphqlFoodProductDetailsTab
                clubDescription={clubDescription}
                shortDescription={product.shortDescription}
                productContents={product.productContents}
                longDescription={product.longDescription}
                productSkus={product.productSkus}
                selectedSku={selectedSku}
                content={content}
                productAttributes={product.attributes}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                isSinglePlaThree={isSinglePlaThree}
                renderDescriptionOnly={renderDescriptionOnly}
                renderContentOnly={renderContentOnly}
                isPdpRedesignEnabled={isPdpRedesignFood}
                productName={product.name}
                partNumber={product.partNumber}
            />
        ));
    }

    if (isPmallAltDescriptionLocation && (product.brand === 'personalizationmall' || product.brand === 'thingsremembered') && pdpVariantName === 'TwoColumnPmallDetailVariant') {
        // show in right column
        response = (
            <GraphqlProductDetailsUIAlt
                productShortDescription={product.shortDescription}
                productContents={product.productContents}
                productLongDescription={product.longDescription}
                partNumber={product.partNumber}
                productBrand={product?.brand}
                presentationFamily={presentationFamily}
                selectedSku={selectedSku}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                isPromoRestricted={product?.isPromoRestricted}
                productBaseContent={productBaseContent}
            />
        );
    }

    if (isPmallAltDescriptionLocation && (product.brand === 'personalizationmall' || product.brand === 'thingsremembered') && pdpVariantName === '') {
        // hide bottom graphqlproductdetailsui component
        response = null;
    }

    return response;
};

ProductDetails.defaultProps = {
    pdpVariantName: '',
    isPassportBundleProduct: {},
    clubDescription: false,
    selectedSku: {},
    content: {},
    showProductDetailsHere: true,
    isPmallAltDescriptionLocation: false,
    isDescriptionTabEnabled: false,
    isSinglePlaThree: false,
    renderDescriptionOnly: false,
    renderContentOnly: false,
    isPDPVariationDesign: false,
    isPdpRedesignEnabled: false,
    isPdpRedesignShortEnabled: false,
    isPlaRedesignEnabled: false,
    isPdpRedesignFood: false,
};

ProductDetails.propTypes = {
    pdpVariantName: string,
    product: shape({
        shortDescription: string.isRequired,
        longDescription: string.isRequired,
        productContents: string.isRequired,
        productSkus: array.isRequired,
        partNumber: string.isRequired,
        brand: string.isRequired,
    }).isRequired,
    partNumber: string.isRequired,
    longDescription: string.isRequired,
    shortDescription: string.isRequired,
    isPassportBundleProduct: shape({
        enable: bool,
        prices: {},
        details: shape({
            bundle_details: shape({
                long_description: string,
            }),
        }),
    }),
    content: shape({
        entries: arrayOf(shape({
            // Gets dynamic data from contentstack. Either image or copy or heading
            additional_information: array,
        })),
    }),
    clubDescription: bool,
    productContents: array.isRequired,
    selectedSku: selectedSkuType,
    showProductDetailsHere: bool,
    productBaseContent: object.isRequired,
    isPmallAltDescriptionLocation: bool,
    isDescriptionTabEnabled: bool,
    isSinglePlaThree: bool,
    renderDescriptionOnly: bool,
    renderContentOnly: bool,
    isPDPVariationDesign: bool,
    isPdpRedesignEnabled: bool,
    isPdpRedesignShortEnabled: bool,
    isPlaRedesignEnabled: bool,
    isPdpRedesignFood: bool,
};

export default ProductDetails;
